import { apiProxyRequest } from "Api/apiProxyRequest";
import type { ProfileDetail, ProfileDetailCreatableFields } from "../types";

export const updateBillingProfileDetailRequest = (
  billingProfileId: string,
  payload: Partial<ProfileDetailCreatableFields>
) => {
  return apiProxyRequest<ProfileDetail>(
    `/billing/profiles/${billingProfileId}`,
    "PATCH",
    payload
  );
};
